module.exports = __webpack_public_path__ + "static/media/art.d70e65d8.png";